/**
 * @generated SignedSource<<3ee70bad12bd34e66e7fc1c76c5cbc89>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpBidModal_nftItem$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpBidModalContent_nftItem">;
  readonly " $fragmentType": "NftPdpBidModal_nftItem";
};
export type NftPdpBidModal_nftItem$key = {
  readonly " $data"?: NftPdpBidModal_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpBidModal_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPdpBidModal_nftItem",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftPdpBidModalContent_nftItem"
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "f2d267ef5025a5e09c8a4ddac45bc80c";

export default node;
